import { WeatherLightningRainyIcon } from './WeatherLightningRainyIcon';

/**
 * author: Austin Andrews
 * id F69033FD-E6F0-48E7-ADA7-7CDF71B1673C
 * name weather-lightning-rainy
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/weather-lightning-rainy.svg
 * tags
 * - Weather 
 */
export const WeatherThunderRainyIcon = WeatherLightningRainyIcon;
export default WeatherThunderRainyIcon